import level1IntroData    from './level1-into.json';
import level1CompleteData from './level1-complete.json';
import level2IntroData    from './level2-intro.json';
import level2CompleteData from './level2-complete.json';
import rotateTipData      from './rotate-tip.json';
import breakWarningData   from './break-warning.json';
import gameOverData        from './game-over.json';
import type { ConsoleScript } from '../../console/types';

export const level1Intro    = level1IntroData    as ConsoleScript;
export const level1Complete = level1CompleteData as ConsoleScript;
export const level2Intro    = level2IntroData    as ConsoleScript;
export const level2Complete = level2CompleteData as ConsoleScript;
export const rotateTip      = rotateTipData      as ConsoleScript;
export const breakWarning   = breakWarningData   as ConsoleScript;
export const gameOver       = gameOverData        as ConsoleScript;
